import { RootState } from "app/rootReducer";
import { Dispatch } from "react";
import { StudentActions } from "./studentSlice";
import { dispatchAsyncFunction, getTokenFromState } from "../sliceHelpers";
import { regenerateStudentPassword } from "api";

const dispatchRegenerateStudentPassword = (studentId: string, actions: StudentActions) => async (
  dispatch: Dispatch<any>,
  getState: () => RootState
) =>
  await dispatchAsyncFunction(async () => {
    const { token } = getTokenFromState(getState);
    const data = await regenerateStudentPassword({ token, studentId });

    dispatch(actions.mergeStudent(data));
  }, dispatch);

export { dispatchRegenerateStudentPassword };
